<template>
  <div :class="{
      'form-popup-overlay': true,
      'is-visible': isVisible,
      'px-5': true
    }"
    @click="hide">
    <div :class="{
        'form-popup': true,
        'px-5': true,
        'pb-4': true,
        'pt-4': true,
        'is-loading': pilotsLoadInProgress
      }"
      @click.stop>
      <h3 class="text-center mb-4">
        Generate ASOC
      </h3>

      <validation-observer
        ref="asoc-config-form"
        tag="form">
        <d-row>
          <d-col cols="12">
            <div class="form-group">
              <validation-provider
                rules="required"
                name="first_name"
                v-slot="{ errors }">
                <label for="name">
                  Contact person in Israel:
                </label>

                <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                  <v-select
                    :options="$root.contactPersons"
                    :reduce="item => item.id"
                    placeholder="Select a contact"
                    label="id"
                    v-model="data.isr_contact_person_id">
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.first_name }} {{ option.last_name }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.first_name }} {{ option.last_name }}
                      </div>
                    </template>
                    <template slot="no-options">
                      There are no contact persons for the provided phrase&hellip;
                    </template>
                  </v-select>
                </div>

                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>

          <d-col cols="12">
            <div class="form-group">
              <validation-provider
                rules="required"
                name="pilot"
                v-slot="{ errors }">
                <label for="name">
                  Pilot:
                </label>

                <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                  <v-select
                    :options="pilots"
                    :reduce="item => item.crew_id"
                    placeholder="Select a pilot"
                    label="id"
                    v-model="data.pilot_id">
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.crew_first_name }} {{ option.crew_last_name }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.crew_first_name }} {{ option.crew_last_name }}
                      </div>
                    </template>
                    <template slot="no-options">
                      There are no contact persons for the provided phrase&hellip;
                    </template>
                  </v-select>
                </div>

                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
        </d-row>
      </validation-observer>

      <d-row>
        <div class="text-center w-100">
          <d-button
            @click.prevent="cancel"
            outline
            theme="secondary"
            class="mr-5">
            Cancel
          </d-button>

          <d-button
            @click.prevent="validateForm"
            theme="success">
            Generate
          </d-button>
        </div>
      </d-row>
    </div>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils';

export default {
  name: 'AsocConfigPopup',
  data () {
    return {
      isVisible: false,
      data: {
        flight_id: false,
        isr_contact_person_id: null,
        pilot_id: null
      },
      pilots: [],
      loadedPilots: false,
      pilotsLoadInProgress: false
    };
  },
  mounted () {
    this.$bus.$on('show-asoc-config-popup', this.show);
  },
  methods: {
    show (id) {
      this.flight_id = id;
      this.loadPilots();

      let contactDefault = this.$root.contactPersons.filter(person => person.is_default);

      if (contactDefault && contactDefault[0]) {
        this.data.isr_contact_person_id = contactDefault[0].id;
      } else {
        this.data.isr_contact_person_id = null;
      }

      setTimeout(() => {
        this.isVisible = true;
      }, 100);
    },
    validateForm () {
      FormUtils.validate(this.$refs['asoc-config-form'], this.submitForm);
    },
    submitForm () {
      this.$bus.$emit('flight-get-asoc-config', {
        flight_id: this.flight_id,
        isr_contact_person_id: this.data.isr_contact_person_id,
        pilot_id: this.data.pilot_id
      })
    },
    cancel () {
      this.isVisible = false;
    },
    hide () {
      this.isVisible = false;
    },
    loadPilots () {
      this.pilotsLoadInProgress = true;

      FormUtils.loadAdditionalData(this, {
        endpoint: '/trips/crews/items',
        params: {
          pagination: 0,
          where: {
            flight_id: this.flight_id
          }
        },
        loadedKey: 'loadedPilots',
        outputKey: 'pilots',
        errorKey: 'loadError',
        successAction: () => {
          this.pilotsLoadInProgress = false;

          if (this.pilots[0]) {
            this.data.pilot_id = this.pilots[0].crew_id;
          } else {
            this.data.pilot_id = null;
          }
        },
        failAction: () => {
          this.pilotsLoadInProgress = false;
        }
      });
    },
  },
  beforeDestroy () {
    this.$bus.$off('show-asoc-config-popup', this.show);
  }
}
</script>
